<template>
    <div class="bill-payment-receipt-popover form">
        <div class="formrow">
            <EmailInput
                v-model:value="emailRecipient"
                ref="emailInputComponent"
                :allowAutocomplete="true"
                :displayIcon="false"
                @submit="sendReceipt"
            />
        </div>
        <SendBillPaymentReceiptButton
            ref="sendReceiptButtonComponent"
            :emailRecipient="emailRecipient"
            :paymentId="paymentId"
            :locationId="locationId"
            :onSendReceiptSuccess="onSendReceiptSuccess"
            :onInvalidEmailProvided="onInvalidEmailProvided"
            :alwaysEnabled="true"
        />
        <PrintBillPaymentReceiptButton
            v-if="isPrintButtonAvailable"
            :paymentId="paymentId"
            :locationId="locationId"
            :onPrintSuccess="onPrintSuccess"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from "vue";

    import EmailInput from "@/components/elements/EmailInput.vue";
    import PrintBillPaymentReceiptButton from "@/components/payment/PrintBillPaymentReceiptButton.vue";
    import SendBillPaymentReceiptButton from "@/components/payment/SendBillPaymentReceiptButton.vue";

    const props = defineProps<{
        locationId: string;
        paymentId: string;
        userIsWaiter: boolean;
        onSendReceiptSuccess: () => void;
        onPrintSuccess: () => void;
    }>();

    // State
    const emailRecipient = ref<string | undefined>();
    const emailInputComponent = ref<InstanceType<typeof EmailInput> | null>(null);
    const sendReceiptButtonComponent = ref<InstanceType<typeof SendBillPaymentReceiptButton> | null>(null);

    // Computed
    const isPrintButtonAvailable = computed(() => props.userIsWaiter);

    // Methods
    function onInvalidEmailProvided() {
        emailInputComponent.value?.setError(true);
        emailInputComponent.value?.focus();
    }

    function sendReceipt() {
        sendReceiptButtonComponent.value?.sendReceipt();
    }
</script>

<style lang="scss">
    .bill-payment-receipt-popover {
        .send-bill-receipt-btn,
        .print-bill-receipt-btn {
            &.v-btn.primary {
                margin: 7px 0 18px !important;
            }
        }
    }
</style>
